<template>
	<div class="code-wrapper">
		<div class="login-img" @click="$router.push('/')">
			<img src="@/assets/images/registerLogin.png" alt="">
		</div>
		<div class="image-container">
			<div class="conter-left">
				<div class="verification-title">驗證您的電子郵件</div>
				<div class="verification-details">
					<div class="verification-subtitle">我們已經將驗證碼發送到</div>
					<div v-if="backStr" class="verification-email">{{ backStr.submitForm.email }}</div>
				</div>
				<div class="verification-instructions">請檢查您的收件箱並從下面輸入驗證碼以驗證您的電子郵件。</div>

				<div class="verification-code-container">
					<input class="numberbox" maxlength='6' v-model="code">
					<input disabled v-for="(digit, index) in 6" :key="index" :value="code[index] || ''"
						@input="handleInput(index)" @keydown.backspace="handleBackspace(index)" maxlength="1"
						:class="[code[index] ? 'active' : '', 'verification-code-input']" ref="inputElements" />
				</div>
				<button v-if="!checking"  @click="regEmail" class="custom-button">
					<span class="button-text">驗證並繼續</span>
				</button>
				<button v-if="checking" class="custom-button">
					<span   class="button-text">正在驗證</span>
				</button>
				<div class="verification-error">找不到驗證碼？請檢查您的垃圾郵件。</div>
				<div class="resend-code" @click="handleResendCode" :class="{ 'disabled': countdown > 0 }">
					{{ countdown > 0 ? countdownText : '重新獲取驗證碼' }}
				</div>
			</div>
			<div class="image-wrapper">
				<img src="@/assets/images/register.png" alt="">
			</div>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
export default {
	data() {
		return {
			partner_id:'',
			code: [],
			codeStr: '',
			countdown: 60,
			backStr: {},
			email: '',
			checking:false
		}
	},
	computed: {
		countdownText() {
			return `重發驗證碼（${this.countdown}s）`;
		},
	},
	created(option) {
		
		console.log(this.code)
		this.backStr = this.$getStorage('localdata')
		this.partner_id = this.$getStorage('partner_id')
		if(!this.partner_id){
			if (this.$route.query.partner_id) {
			    this.partner_id = this.$route.query.partner_id
				this.$setStorage('partner_id', this.partner_id)
			}
		}else{
			console.log('partner_id:',this.partner_id)
		}
		
	},
	methods: {
		handleInput(index) {
			console.log('index:',index)
			if (this.code[index].length === 1) {
				if (index < 5) {
					this.$refs.inputElements[index + 1].focus();
				}
			} else if (this.code[index].length === 0) {
				if (index > 0) {
					this.$refs.inputElements[index - 1].focus();
				}
			}
		},
		handleBackspace(index) {
			if (index > 0 && this.code[index].length === 0) {
				this.$refs.inputElements[index - 1].focus();
			}
		},
		handleResendCode() {
			if (this.countdown === 0) {
				// 启动倒计时，发送验证码
				this.code = []
				this.sendEmail()
				this.startCountdown();
			}
		},
		startCountdown() {
			this.countdown = 60;
			const timer = setInterval(() => {
				if (this.countdown > 0) {
					this.countdown--;
				} else {
					clearInterval(timer);
				}
			}, 1000);
		},
		async regEmail() {
			if(this.checking){
				console.log('checking... can not do this ')
				return
			}


			this.codeStr = this.code[0] + this.code[1] + this.code[2] + this.code[3] + this.code[4] + this.code[5]
			console.log(this.codeStr)
			if(this.codeStr.length != 6){
				console.log('checking... can not do this1 ')
				return
			}
			let fdata = {
				do: 'Register',
				email: this.backStr.submitForm.email,
				password: this.backStr.submitForm.password,
				contact: this.backStr.submitForm.mobile,
				registerRef: this.backStr.registerRef,
				code: this.codeStr,
				partner_id:this.partner_id
			}

			this.checking = true 
			let res = await this.$api.funk(fdata)

			if (res.retDescr == 'Success') {
				console.log('reg ok ');
				this.$message.success('註冊成功！');
				this.checking = false
				this.$router.push({ path: '/selectionCriteria' })
			} else {
				this.code = [];
				this.checking = false
				this.$message.error(res.retDescr);
			}
		},
		async sendEmail() {

			let fdata = { do: 'Send_email_otp', email: this.backStr.submitForm.email }
			let res = await this.$api.funk(fdata)
			if (res.retDescr == 'Success') {
				this.backStr.registerRef = res.registerRef

				this.code = [];
				this.countdown = 60
				console.log('send email to:' + this.backStr.submitForm.email);

				//this.$router.push({ path: '/code' })
			} else {
				console.log('error send email ');
			}
		},
	},
	mounted() {
		
		this.inputElements = this.$refs.inputElements;
		this.startCountdown()
	}
}
</script>

<style lang="scss" scoped>
.code-wrapper {
	padding: 0.24rem 0.24rem 0.24rem 0.4rem;

	/* Add the following media query for mobile devices */
	@media (max-width: 768px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100vh;
	}

	.login-img {
		position: absolute;
		left: 0;
		top: 0;
		cursor: pointer;

		img {
			margin-top: 0.16rem;
			margin-left: 0.40rem;
			width: 1.04rem;
			height: 0.48rem;
			display: block;
		}

	}

	.image-container {
		display: flex;
		justify-content: space-between;

		.conter-left {
			margin-right: 3.02rem;
			padding-top: 1.80rem;

			@media (max-width: 768px) {
				margin-right: 0;
				margin-top: 0.40rem;
				padding-top: 0rem;

			}

			.verification-title {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 600;
				font-size: 0.40rem;
				line-height: 0.56rem;
				/* identical to box height */
				color: #000000;
			}

			.verification-details {
				display: flex;
				padding-top: 0.24rem;

				.verification-subtitle {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 0.26rem;
					line-height: 0.28rem;
					color: #000000;
				}

				.verification-email {
					padding-left: 0.08rem;
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 0.26rem;
					line-height: 0.28rem;
					color: #E02E43;
				}
			}

			.verification-instructions {
				padding-top: 0.08rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.26rem;
				line-height: 0.28rem;
				color: #666666;
			}

			.custom-button {
				margin-top: 0.80rem;
				width: 100%;
				background: #E02E43;
				border-radius: 0.08rem;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0.24rem;
			}

			.verification-error {
				margin-top: 0.24rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.26rem;
				line-height: 0.28rem;
				color: #666666;
			}

			.resend-code {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.26rem;
				line-height: 0.28rem;
				text-decoration-line: underline;
				color: #E02E43;
				cursor: pointer;
				padding-top: 0.08rem;
			}

			.resend-code.disabled {
				pointer-events: none;
				opacity: 0.5;
			}

			.button-text {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.32rem;
				color: #FFFFFF;
				cursor: pointer;
			}


			.verification-code-container {
				display: flex;
				justify-content: center;
				margin-top: 0.8rem;
				position: relative;
				height: 0.56rem;

				.numberbox {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					opacity: 0;
					font-size: 0.24rem;
					z-index: 100;
				}

				&>*:not(:first-child) {
					margin-left: 20px;
				}

				.verification-code-input {
					width: 1.16rem;
					height: 0.56rem;
					// margin: 0 10px;
					padding: 0;
					text-align: center;
					font-size: 0.24rem;
					opacity: 0.5;
					border: 2px solid #000000;
					border-radius: 0.04rem;

					&.active {
						border-color: #E02E43;
					}
				}

				.verification-code-input:focus {
					outline: none;
				}
			}
		}

		.image-wrapper {
			width: 7.76rem;
			border-radius: 0.3rem;
			overflow: hidden;

			/* Add the following styles for mobile devices */
			@media (max-width: 768px) {
				display: none;
			}
		}

		.image-wrapper img {
			width: 100%;
			object-fit: cover;
			display: block;
		}
	}
}

@media (max-width: 750px) {
	.code-wrapper .login-img {
		left: 0.4rem;
		top: 0.4rem;
	}

	.code-wrapper .login-img img {
		height: 0.8rem;
		width: inherit;
		margin: 0;

	}

	.code-wrapper {
		padding: 0.4rem;
		display: block;
	}

	.code-wrapper .image-container {
		height: auto;
		margin: 0;
		display: block;
		margin-top: 2rem;
	}

	.code-wrapper .image-container .conter-left .verification-details .verification-subtitle,
	.code-wrapper .image-container .conter-left .verification-instructions {
		font-size: 0.24rem;
		line-height: 0.26rem;
	}

	.code-wrapper .image-container .conter-left .verification-code-container {
		justify-content: space-between;
		height: 0.8rem;
	}

	.code-wrapper .image-container .conter-left .verification-code-container .verification-code-input {
		width: 1rem;
		height: 0.8rem;
		margin: 0;
	}

	.code-wrapper .image-container .conter-left .custom-button {
		margin-top: 0.8rem;
		width: 100%;
		background: #E02E43;
		border-radius: 0.08rem;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0.46rem 0;
		border-radius: 0.14rem;

	}

	.code-wrapper .image-container .conter-left .button-text {
		font-size: 0.4rem;
		line-height: 0.4rem;
	}

	.code-wrapper .image-container .conter-left .verification-error {
		margin-top: 0.4rem;
		font-size: 0.24rem;
		line-height: 0.26rem;
	}

	.code-wrapper .image-container .conter-left .resend-code {
		font-size: 0.24rem;
		line-height: 0.26rem;
		margin-top: 0.1rem;
	}
}
</style>
